import CheckIcon from '@mui/icons-material/Check';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import React, { useState } from 'react';
import Carousel from 'react-material-ui-carousel';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ExitPopup5498s from '@/components/ui/ExitPopup5498s ';
import PricingDetailsInfoWage from '@/components/ui/PricingDetailsInfoWage';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1098Series = () => {
  // const [hoveredImageIndex, setHoveredImageIndex] = useState<string | null>(
  //   null
  // );

  // const handleMouseOver = (id: string) => {
  //   setHoveredImageIndex(id);
  // };

  // const handleMouseOut = () => {
  //   setHoveredImageIndex(null);
  // };
  const DEFAULT_ACTIVE_ID = 'f5498-who-file-img';

  const [hoveredImageIndex, setHoveredImageIndex] =
    useState<string>(DEFAULT_ACTIVE_ID);

  const [previousHoveredId, setPreviousHoveredId] =
    useState<string>(DEFAULT_ACTIVE_ID);

  const handleMouseOver = (id: string) => {
    setPreviousHoveredId(hoveredImageIndex);
    setHoveredImageIndex(id);
  };

  const handleMouseOut = () => {
    setHoveredImageIndex(previousHoveredId);
  };
  const getOpacity = (id: string) => (hoveredImageIndex === id ? 1 : 0.5);
  const [expanded, setExpanded] = useState<string>('panel1');
  const [activeImage, setActiveImage] = useState<string>('image-1');
  const handleAccordionChange =
    (panel: string, imageId: string) =>
    (_event: React.SyntheticEvent, _isExpanded: boolean) => {
      if (expanded === panel) return;

      setExpanded(panel);
      setActiveImage(imageId);
    };

  const [isPriceView5498s, setIsPriceView5498s] = React.useState(false);
  const images = [
    {
      label: (
        <React.Fragment>
          I used TaxZerone for my 5498-SA filing, and it was excellent. The
          process was simple, error-free, and I got instant confirmation from
          the IRS. Highly recommend!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Sophia Davis
          </Typography>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          Great experience filing 5498-ESA through TaxZerone. The instructions
          were clear, and I saved so much time compared to manual filing.
          Fantastic service!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Mason Reed
          </Typography>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          Filing Form 5498 was super easy with TaxZerone! The platform guided me
          step by step and ensured my filing was accurate. Super quick and easy.
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Abigail Clark
          </Typography>
        </React.Fragment>
      ),
    },
  ];
  return (
    <AppLayout
      meta={
        <Meta
          title="E-File IRS Form 5498 Series for 2025 tax year with TaxZerone"
          description="E-File IRS Form 5498, 5498-ESA, and 5498-SA at transparent & affordable prices using TaxZerone. Choose the right form, file securely, and stay IRS-compliant."
          keywords=""
          canonical="form-5498-series/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <ExitPopup5498s
        isPriceView5498s={isPriceView5498s}
        setIsPriceView5498s={setIsPriceView5498s}
      />
      <InformationSubMenu />

      <Box sx={{ maxWidth: 1920, mx: 'auto' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 5498 Series</span>
                </span>{' '}
                for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                If you are responsible for managing IRAs, HSAs, ESAs, or QAs,
                filing the{' '}
                <span style={{ fontWeight: 600 }}> IRS Form 5498 series</span>{' '}
                is an essential part of year-end reporting.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Get Started Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                m={0}
                mt={{ xs: 2, md: 5 }}
                pb={0}
                textAlign="center"
                sx={{ ml: { xs: 0, md: -5 } }}
              >
                <Grid size={{ xs: 4, sm: 4, md: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/secure-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/secure-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/secure-new-icon.png"
                          alt="Safe & Secure"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Safe &
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Secure
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 4, sm: 4, md: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/irs-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/irs-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/irs-new-icon.png"
                          alt="IRS Authorized"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      IRS
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Authorized
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 4, sm: 4, md: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 1, sm: 2 },
                      borderRadius: 0,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/lowest-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/lowest-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/lowest-new-icon.png"
                          alt="Affordable Price"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Affordable
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Filing Fee
                    </strong>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="form-5498-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f5498s-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/f5498s-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/f5498s-landing-img.png"
                  alt="E-File Form 5498 Series for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="form-5498-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f5498s-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/f5498s-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/f5498s-landing-img-sm.png"
                  alt="E-File IRS Form 5498 Series for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 3 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <PricingDetailsInfoWage
                formName="5498 Forms"
                colorCode="#4269e2"
              />{' '}
              <Typography variant="body1" sx={{ mb: 2, textAlign: 'right' }}>
                <Link
                  sx={{ color: '#0202ff', cursor: 'pointer' }}
                  onClick={() => setIsPriceView5498s(true)}
                >
                  How TaxZerone’s Pricing Works?
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          mb: 4,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 3 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Pricing Includes
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5, sm: 4 }}
              textAlign="center"
              sx={{
                display: 'flex',
                alignSelf: 'end',
                alignItems: 'flex-end',
                placeContent: { sm: 'end', xs: 'center' },
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  p: 2,
                  borderRadius: 3,
                  minHeight: '100%',

                  textAlign: 'left',

                  maxWidth: 400,
                }}
              >
                <Stack spacing={1} direction="column">
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Bulk Filing{' '}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Schedule Filing
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Transmittal Form 1096
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      USPS Address Validation
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Error Checks
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Expert Support
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Grid>

            <Grid
              size={{ xs: 12, md: 7, sm: 8 }}
              sx={{
                mt: 0,
                textAlign: 'center',
                justifyContent: 'center',
                alignSelf: 'start',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 22, sm: 20, xs: 18 },
                  textAlign: 'center',
                  fontWeight: 600,
                  mt: 0,
                  mb: 1,
                }}
              >
                Add-ons Available{' '}
              </Typography>
              <Box sx={{ mb: 5, maxWidth: 600, m: 'auto' }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 1 }}
                >
                  <Table aria-label="EFW Individual">
                    <TableHead>
                      {/* <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Aspect
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          IRP (International Registration Plan)
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          IFTA (International Fuel Tax Agreement)
                        </TableCell>
                      </TableRow> */}
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Electronic Delivery
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $ 0.50
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Postal Mailing
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $1.75
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: { md: 8, sm: 4, xs: 3 } }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                E-File Form 5498 series with TaxZerone
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="right"
              sx={{
                rowGap: 1,
                position: 'relative',
                // maxWidth: '450px',
                display: 'flex',
                justifyContent: 'right',
                m: 'auto',
                alignContent: 'right',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  maxWidth: '363px',
                  borderWidth: 2,
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#ffe6a7',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-5498/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f5498-ira-contribution-img.webp" />
                      <source srcSet="/assets/images/f5498-ira-contribution-img.png" />
                      <img
                        src="/assets/images/f5498-ira-contribution-img.png"
                        alt="IRA Contribution Information"
                        className="partner-card"
                        loading="lazy"
                        width={359}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                          // aspectRatio: 3 / 2,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          textTransform: 'uppercase',
                        }}
                      >
                        Form 5498
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 2,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      IRA Contribution Information
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)', mb: 3 }}
                    >
                      Report annual contributions, Rollovers, Fair Market Value,
                      and other information for IRAs, HSAs, Archer MSAs, and
                      Coverdell ESAs.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
                  >
                    E-File 5498
                  </Button>
                </Box>
              </Paper>
            </Grid>

            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#264653',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-5498-esa/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f5498esa-coverdell-esa-img.webp" />
                      <source srcSet="/assets/images/f5498esa-coverdell-esa-img.png" />
                      <img
                        src="/assets/images/f5498esa-coverdell-esa-img.png"
                        alt="Coverdell ESA Contribution Information"
                        className="partner-card"
                        loading="lazy"
                        width={359}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 5498-ESA
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Coverdell ESA Contribution Information
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)', mb: 4 }}
                    >
                      Report annual contributions made to a Coverdell Education
                      Savings Account (ESA).
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
                  >
                    E-File 5498-ESA
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#ca6702',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-5498-sa/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f5498sa-medicare-advantage-img.webp" />
                      <source srcSet="/assets/images/f5498sa-medicare-advantage-img.png" />
                      <img
                        src="/assets/images/f5498sa-medicare-advantage-img.png"
                        alt="HSA, Archer MSA, or Medicare Advantage MSA Information"
                        className="partner-card"
                        loading="lazy"
                        width={359}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 4 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 5498-SA
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      HSA, Archer MSA, or Medicare Advantage MSA Information
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)', mb: 1 }}
                    >
                      Report contributions made to Health Savings Accounts
                      (HSAs), Archer MSAs, or Medicare Advantage MSAs.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
                  >
                    E-File 5498-SA
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#023e8a',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-5498-qa/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f5498qa-able-account-img.webp" />
                      <source srcSet="/assets/images/f5498qa-able-account-img.png" />
                      <img
                        src="/assets/images/f5498qa-able-account-img.png"
                        alt="ABLE account contribution Information"
                        className="partner-card"
                        loading="lazy"
                        width={359}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 5498-QA
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      ABLE account contribution Information
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Report annual contributions, rollovers, designated
                      beneficiary details, fair market value, and other
                      information for Qualified ABLE (Achieving a Better Life
                      Experience) accounts.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
                  >
                    E-File 5498-QA
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            // direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  // mt: { xs: -3, md: -5, lg: -8 },
                }}
              >
                <img
                  src={
                    hoveredImageIndex !== null
                      ? `/assets/images/${hoveredImageIndex}.webp`
                      : '/assets/images/f5498-who-file-img.webp'
                  }
                  alt="Who Should File Form 5498s?"
                  className="img-responsive"
                  loading="lazy"
                  width={550}
                  height={550}
                  style={{ borderRadius: 21 }}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                }}
              >
                Who Should File Form 5498s?
              </Typography>

              <Box
                component="ul"
                sx={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  textAlign: 'left',
                  ml: { xs: 0, sm: 3 },
                  mt: { xs: 0, md: 3 },
                  mb: { xs: 0, md: 4 },
                  '& li': { display: 'flex' },
                }}
              >
                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f5498-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f5498-who-file-img'),
                    transition: 'opacity 0.2s ease-in-out',
                  }}
                >
                  <li style={{ marginBottom: 10 }}>
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>Form 5498 </span>
                      <br />
                      Banks, credit unions, and other custodians that manage
                      Individual Retirement Accounts (IRAs).
                    </Box>
                  </li>
                </Box>

                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f5498esa-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f5498esa-who-file-img'),
                    transition: 'opacity 0.2s ease-in-out',
                  }}
                >
                  <li style={{ marginBottom: 10 }}>
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>Form 5498-ESA</span>
                      <br />
                      Organizations that administer Coverdell Education Savings
                      Accounts (ESAs).
                    </Box>
                  </li>
                </Box>

                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f5498sa-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f5498sa-who-file-img'),
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                >
                  <li style={{ marginBottom: 10 }}>
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>Form 5498-SA </span>
                      <br />
                      Institutions responsible for Health Savings Accounts
                      (HSAs) and Archer MSAs.
                    </Box>
                  </li>
                </Box>
                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f5498qa-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f5498qa-who-file-img'),
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                >
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Form 5498-QA </span>{' '}
                      <br />
                      Organizations that administer Qualified ABLE (Achieving a
                      Better Life Experience) accounts.
                    </Box>
                  </li>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 32, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                Why Should You File Form 5498s?
              </Typography>

              <Box
                component="ul"
                sx={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  textAlign: 'left',
                  ml: { xs: 0, sm: 3 },
                  mt: { xs: 0, md: 3 },
                  mb: { xs: 0, md: 3 },
                  '& li': { display: 'flex' },
                }}
              >
                {' '}
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      IRS Reporting Requirement{' '}
                    </span>{' '}
                    <br />
                    Filing Form 5498 is mandatory to report contributions,
                    rollovers, recharacterizations, and fair market values to
                    the IRS.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Informing Account Holders{' '}
                    </span>{' '}
                    <br />
                    Recipients use the information on Form 5498 to verify their
                    contributions and ensure accurate reporting on their
                    personal tax returns.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Maintaining Compliance
                    </span>{' '}
                    <br />
                    Timely filing helps trustees and custodians avoid IRS
                    penalties for missing or incorrect submissions.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Transparency & Recordkeeping
                    </span>{' '}
                    <br />
                    Provides account holders with a verified record of their
                    annual contributions for retirement, health, or education
                    accounts.
                  </Box>
                </li>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }} sx={{ position: 'relative' }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f5498-why-should-file-img.webp" />
                  <source srcSet="/assets/images/f5498-why-should-file-img.png" />
                  <img
                    src="/assets/images/f5498-why-should-file-img.png"
                    alt="Why Should You File Form 5498s?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={500}
                  />
                </picture>
              </Box>
              {/* <Hidden mdDown>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 230 },
                    alignSelf: 'center',
                    maxWidth: '100%',
                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    top: { ld: 40, md: 0 },
                    right: { lg: 430, md: 290, sm: 360 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/accurate-records-icon.webp" />
                      <source srcSet="/assets/images/accurate-records-icon.png" />
                      <img
                        src="/assets/images/accurate-records-icon.png"
                        alt="Maintain Accurate Records"
                        // className="img-responsive"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { lg: 16, md: 15 },
                        alignContent: 'center',
                        textAlign: 'center',
                      }}
                    >
                      Accurate Records
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 240, sm: 180 },
                    alignSelf: 'center',

                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    bottom: { lg: 160, md: 0 },
                    right: { lg: 390, md: 270 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/build-trust-icon.webp" />
                      <source srcSet="/assets/images/build-trust-icon.png" />
                      <img
                        src="/assets/images/build-trust-icon.png"
                        alt="Build Trust & Credibility"
                        // className="img-responsive"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { lg: 16, md: 15 },
                        alignContent: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Build Trust & Credibility
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 200 },
                    alignSelf: 'center',

                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    top: { lg: 150, md: 300 },
                    left: { lg: 350, md: 370 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/audit-risks-icon.webp" />
                      <source srcSet="/assets/images/audit-risks-icon.png" />
                      <img
                        src="/assets/images/audit-risks-icon.png"
                        alt="Audit Risks"
                        // className="img-responsive"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 16, sm: 17, xs: 16 },
                        alignContent: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Reduce Audit Risks
                    </Typography>
                  </Box>
                </Box>
              </Hidden> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-File IRS 5498 forms using TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: 2, mb: 0, fontSize: { md: 18, sm: 16, xs: 16 } }}
              >
                E-File your 5498 Forms in 3 Simple Steps
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/5498-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/5498-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/5498-steps-img.png"
                  alt="E-File your 5498 Forms in 3 Simple Steps"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                m: '0',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              {/* <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                How it works:
              </Typography> */}
              <Box>
                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          my: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/step-1-icon.webp"
                            width={39}
                            height={39}
                          />
                          <source
                            srcSet="/assets/images/step-1-icon.png"
                            width={39}
                            height={39}
                          />
                          <img
                            src="/assets/images/step-1-icon.png"
                            alt="Enter the required details"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Enter the required details{' '}
                        </span>{' '}
                        <br />
                        Enter the trustee or custodian and account holder
                        details.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          m: 0,
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-2-icon.webp" />
                          <source srcSet="/assets/images/step-2-icon.png" />
                          <img
                            src="/assets/images/step-2-icon.png"
                            alt="Provide the account details"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        <span style={{ fontWeight: 600 }}>
                          Provide the account details{' '}
                        </span>{' '}
                        <br />
                        Fill in the required details for each account holder
                        including their account type and contribution amount
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-3-icon.webp" />
                          <source srcSet="/assets/images/step-3-icon.png" />
                          <img
                            src="/assets/images/step-3-icon.png"
                            alt="Transmit to the IRS"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography variant="body1">
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Transmit to the IRS{' '}
                        </span>{' '}
                        <br />
                        Review and securely transmit the return to the IRS.
                        Deliver recipient copies electronically via ZeroneVault.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: { xs: 2, sm: 4 },
                      mb: { xs: 2, sm: 2, md: 5 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
                  >
                    E-File Now
                  </Button>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Benefits of E-Filing the Form 5498 Series with TaxZerone
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone simplifies information return filing with these
                amazing features
              </Typography> */}
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized
                </Typography>
                <Typography variant="body1">
                  File your forms with TaxZerone - an IRS authorized e-file
                  provider. We make sure your submissions are handled with high
                  accuracy.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/zeronevault-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/zeronevault-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/zeronevault-icon.png"
                      alt="Recipient Copy Distribution"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Recipient Copy Distribution
                </Typography>
                <Typography variant="body1">
                  Easily deliver recipient copies via{' '}
                  <Link
                    href="https://taxzerone.zeronevault.com/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    ZeroneVault
                  </Link>{' '}
                  - fast, secure, and fully IRS-compliant!
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/review-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/review-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/review-icon.png"
                      alt="Smart Validation System"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Validation System
                </Typography>
                <Typography variant="body1">
                  Ensure your return is accurate and IRS compliant with our
                  advanced validation system which will help you avoid errors.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#76ce97',
                  borderRadius: 10,
                  // mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/iris-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/iris-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/iris-icon.png"
                      alt="IRIS Support "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRIS Support
                </Typography>
                <Typography variant="body1">
                  TaxZerone supports{' '}
                  <span style={{ fontWeight: 600 }}> IRIS</span> (Information
                  Returns Intake System) for all electronic filing of
                  information return.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Filing
                </Typography>
                <Typography variant="body1">
                  Having multiple forms to file? Our{' '}
                  <span style={{ fontWeight: 600 }}> bulk filing feature</span>{' '}
                  allows you to upload and file thousands of returns in just a
                  few clicks.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  // mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Schedule Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Schedule Filing
                </Typography>
                <Typography variant="body1">
                  With our{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    schedule filing feature,
                  </span>{' '}
                  you can prepare the returns ahead of time and choose the exact
                  date you want them submit to the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/real-time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/real-time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/real-time-icon.png"
                      alt="Real-Time Updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Updates
                </Typography>
                <Typography variant="body1">
                  From submission to acceptance, track the status of your
                  filings. Get{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    instant notifications
                  </span>{' '}
                  and stay always in the loop.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#76ce97',
                  borderRadius: 10,
                  // mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  Whether you are filing one form or many, our{' '}
                  <span style={{ fontWeight: 600 }}> affordable pricing</span>{' '}
                  makes sure you only pay for what you need - no hidden fees.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Support
                </Typography>
                <Typography variant="body1">
                  Having Queries? Our dedicated support team is here to assist
                  you via Email, Phone (in English & Spanish) and Live chat.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
        <Grid
          container
          spacing={2}
          m={2}
          mt={{ xs: 5, sm: 5, md: 10 }}
          mb={{ xs: 5, sm: 5, md: 10 }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Stack
              direction="row"
              spacing={1}
              sx={{ mb: 2 }}
              justifyContent={{ xs: 'center', md: 'center' }}
            >
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-1"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-2"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-3"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-4"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-5"
              />
            </Stack>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 1, sm: 3 },
              }}
            >
              Hear What Our Clients Say About Us
            </Typography>

            <Carousel
              animation="fade"
              navButtonsAlwaysVisible
              indicatorIconButtonProps={{
                style: {
                  marginTop: '0px', // 5
                  textAlign: 'right', // 4
                  paddingBottom: '0px',
                  marginBottom: '0px',
                },
              }}
              className="carousel"
            >
              {images.map((step, index) => (
                <Box
                  component="div"
                  sx={{
                    p: 2,
                    textAlign: 'center',

                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    mx: { xs: -2, sm: 'auto' },
                    maxWidth: 800,
                    minHeight: { xs: 200, sm: 170, md: 220 },
                  }}
                  key={index}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &ldquo;
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    color="gray"
                    sx={{
                      fontSize: { xs: 18, sm: 22, md: 30 },
                      fontFamily: 'san-serif',
                      fontStyle: 'italic',
                      color: '#414042',
                      lineHeight: 1.2,
                    }}
                  >
                    {step.label}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &rdquo;
                  </Typography>
                </Box>
              ))}
            </Carousel>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            mb={6}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Common Use Cases
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Accordion
                expanded={expanded === 'panel1'}
                onChange={handleAccordionChange('panel1', 'image-1')}
                sx={{
                  background: 'transparent',
                  borderTop: 'none',
                  '&:before': { display: 'none' },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: { md: 18, sm: 18, xs: 16 },
                      fontWeight: 600,
                    }}
                  >
                    Form 5498
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 2, md: 0 },
                      mb: { xs: 0, sm: 6, md: 2 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Documenting rollover contributions from other retirement
                        plans{' '}
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Recording recharacterizations or conversions between IRA
                        types
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Providing year-end fair market value (FMV) of IRA
                        accounts
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Reporting required minimum distribution (RMD) details
                      </Box>
                    </li>
                  </Box>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === 'panel2'}
                onChange={handleAccordionChange('panel2', 'image-2')}
                sx={{
                  background: 'transparent',
                  borderTop: 'none',
                  '&:before': {
                    display: 'none',
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: { md: 18, sm: 18, xs: 16 },
                      fontWeight: 600,
                    }}
                  >
                    Form 5498-ESA
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 2, md: 0 },
                      mb: { xs: 0, sm: 6, md: 2 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Recording rollovers or transfers into an ESA</Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Providing contribution details to parents/ beneficiaries
                        for education expense tracking.
                      </Box>
                    </li>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === 'panel3'}
                onChange={handleAccordionChange('panel3', 'image-3')}
                sx={{
                  background: 'transparent',
                  borderTop: 'none',
                  '&:before': {
                    display: 'none',
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: { md: 18, sm: 18, xs: 16 },
                      fontWeight: 600,
                    }}
                  >
                    Form 5498-SA
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 2, md: 0 },
                      mb: { xs: 0, sm: 6, md: 2 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Documenting contributions to Archer MSAs or Medicare
                        Advantage MSAs
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Tracking employer vs. employee contributions for
                        healthcare savings accounts
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Providing recipients with annual HSA/MSA contribution
                        summaries
                      </Box>
                    </li>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === 'panel4'}
                onChange={handleAccordionChange('panel4', 'image-4')}
                sx={{
                  background: 'transparent',
                  borderTop: 'none',
                  '&:before': {
                    display: 'none',
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4-content"
                  id="panel4-header"
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: { md: 18, sm: 18, xs: 16 },
                      fontWeight: 600,
                    }}
                  >
                    Form 5498-QA
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 2, md: 0 },
                      mb: { xs: 0, sm: 6, md: 2 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Documenting annual contributions made to Qualified ABLE
                        (Achieving a Better Life Experience) accounts.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Recording rollovers or transfers from other ABLE
                        accounts or 529 plans
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Providing year-end fair market value (FMV) of ABLE
                        accounts
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Supplying beneficiaries with annual ABLE account
                        contribution and balance summaries
                      </Box>
                    </li>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box sx={{ width: 'auto', height: 550 }}>
                {activeImage === 'image-1' && (
                  <img
                    src="/assets/images/f5498-common-img.webp"
                    alt="Formn 5498 common use"
                    className="img-responsive"
                    width={600}
                    height={550}
                  />
                )}

                {activeImage === 'image-2' && (
                  <img
                    src="/assets/images/f5498esa-common-img.webp"
                    alt="Formn 5498-ESA common use"
                    className="img-responsive"
                    width={600}
                    height={550}
                  />
                )}
                {activeImage === 'image-3' && (
                  <img
                    src="/assets/images/f5498sa-common-img.webp"
                    alt="Formn 5498-SA common use"
                    className="img-responsive"
                    width={600}
                    height={550}
                  />
                )}
                {activeImage === 'image-4' && (
                  <img
                    src="/assets/images/f5498qa-common-img.webp"
                    alt="Formn 5498-QA common use"
                    className="img-responsive"
                    width={600}
                    height={550}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Competitor Comparison: Why Choose TaxZerone
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                for 5498 Series E-Filing
              </Typography>
              <Box component="div" sx={{ mb: 3, backgroundColor: '#fff' }}>
                <TableContainer sx={{}}>
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                          }}
                        >
                          Feature
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Other E-file Platforms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Paper Filing (Manual)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          IRS-Authorized E-File Provider
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Yes{' '}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Varies
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          No
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Form Coverage
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          Supports all 5498 series (5498, 5498-ESA, 5498-SA)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Limited coverage (not all forms supported)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not Applicable
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Pricing
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          As low as{' '}
                          <span style={{ fontWeight: 600, fontSize: 15 }}>
                            $0.59 per form
                          </span>{' '}
                          <br />
                          (for 1000+)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Higher filing fees, hidden charges
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          Printing, postage & manual costs
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Real-Time Error Validation
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Automatic validation before IRS submission</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited checks
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Manual review only
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Bulk Upload
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          Accepts extension files
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited or unavailable
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not possible
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Corrections & Re-file
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Free corrections for rejected returns</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Extra charges
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          <Box>Manual corrections, resubmission delays</Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Delivery Options
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          E-delivery & Postal Mailing
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Manual printing & mailing
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Recipient Access Portal
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>
                            <Link
                              href="https://www.zeronevault.com/"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              ZeroneVault
                            </Link>{' '}
                            (Secure & <br />
                            IRS-compliant portal)
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Filing Scheduler
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Schedule filings in advance
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not possible
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Reminders
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Email reminders sent before IRS deadlines</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Customer Support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          U.S. based support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Limited or email-only
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          None
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ready to efile IRS Form 5498 Series?
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mb: 2,
          }}
        >
          E-file securely with TaxZerone — IRS authorized, simple, and
          affordable.
          <Hidden smDown>
            <br />
          </Hidden>{' '}
          Stay compliant, save time, and experience smooth support every step of
          the way.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f5498series`}
          >
            Start E-Filing
          </Button>
        </Box>
      </Box>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, md: 9, sm: 10 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What forms are included in the 5498 series?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-5498/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 5498
                        </Link>{' '}
                        - Report contributions, rollovers, fair market value
                        (FMV), and required minimum distributions (RMDs) for
                        Individual Retirement Arrangements (IRAs).
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-5498-esa/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 5498-ESA
                        </Link>{' '}
                        - Report contributions to a Coverdell Education Savings
                        Account (ESA).
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-5498-sa/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 5498-SA
                        </Link>{' '}
                        - Report contributions and FMV of Health Savings
                        Accounts (HSAs), Archer MSAs, and Medicare Advantage
                        MSAs.
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-5498-qa/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 5498-QA
                        </Link>{' '}
                        - Report contributions, rollovers, and fair market value
                        (FMV) for Qualified ABLE (Achieving a Better Life
                        Experience) accounts.
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Who needs to file Form 5498 series?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Any financial institution, bank, or trustee that manages
                      IRAs, HSAs, MSAs, ESAs, or QAs is required to file the
                      applicable Form 5498 series with the IRS and send a copy
                      to the account holder
                    </Typography>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Do I need to send recipient copies?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Yes, you must provide a completed copy of the form to each
                    account holder, either by mail or electronically. TaxZerone
                    helps you to securely deliver your recipient’s copy through{' '}
                    <Link
                      href="https://taxzerone.zeronevault.com/"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      ZeroneVault
                    </Link>
                    .
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ borderTop: '1px solid #ccc' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              New here?
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 22, md: 20, sm: 18, xs: 18 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Get the support you need.
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4, sm: 6 }}>
            {/* <Link href="/resources/" sx={{ textDecoration: 'none' }}> */}
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                py: 3,
                textAlign: 'center',
                borderWidth: 2,
                borderColor: 'transparent',
                borderRadius: 5,
                height: '100%',
                backgroundColor: '#f0f2f9',
                '&:hover': {
                  cursor: 'pointer',
                  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                  textAlign: 'center',
                }}
              >
                Resources
              </Typography>
              <Typography variant="body1">
                Explore the{' '}
                <Link
                  href="/resources/information-returns/form-5498-instructions/"
                  sx={{ color: '#0202ff' }}
                >
                  instructions of form 5498
                </Link>
                ,{' '}
                <Link
                  href="/resources/information-returns/form-5498-esa-instructions/"
                  sx={{ color: '#0202ff' }}
                >
                  instructions of form 5498-esa
                </Link>
                ,{' '}
                <Link
                  href="/resources/information-returns/form-5498-sa-instructions/"
                  sx={{ color: '#0202ff' }}
                >
                  instructions of form 5498-sa
                </Link>{' '}
                and tips to make filing your 5498 series forms simple and Quick.
              </Typography>
            </Paper>
            {/* </Link> */}
          </Grid>
          <Grid size={{ xs: 12, md: 4, sm: 6 }}>
            {/* <Link
              href="https://blog.taxzerone.com/"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            > */}
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                py: 3,
                textAlign: 'center',
                borderWidth: 2,
                borderColor: 'transparent',
                borderRadius: 5,
                height: '100%',
                backgroundColor: '#f0f2f9',
                '&:hover': {
                  cursor: 'pointer',
                  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                  textAlign: 'center',
                }}
              >
                Blogs
              </Typography>
              <Typography variant="body1">
                Stay informed with blogs covering IRS updates,{' '}
                <Link
                  href="https://blog.taxzerone.com/posts/dont-miss-important-deadline-for-irs-form-5498-series-for-the-2024-tax-year/"
                  target="_blank"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  IRS deadlines for 5498 forms
                </Link>
                , and smart filing strategies to ensure your 5498 forms are
                accurate and on time.
              </Typography>
            </Paper>
            {/* </Link> */}
          </Grid>
          <Grid size={{ xs: 12, md: 4, sm: 6 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                py: 3,
                textAlign: 'center',
                borderWidth: 2,
                borderColor: 'transparent',
                borderRadius: 5,
                height: '100%',
                backgroundColor: '#f0f2f9',
                '&:hover': {
                  cursor: 'pointer',
                  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                  textAlign: 'center',
                }}
              >
                Support Article
              </Typography>
              <Typography variant="body1">
                Not sure where to begin? Our Support articles will guide you
                through the{' '}
                <Link
                  href="https://support.taxzerone.com/?s=5498&asl_active=1&p_asl_data=1&customset[]=e-landing-page&customset[]=page&customset[]=post&asl_gen[]=excerpt&asl_gen[]=content&asl_gen[]=title&qtranslate_lang=0&filters_initial=1&filters_changed=0"
                  target="_blank"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  5498 forms filing process
                </Link>{' '}
                with clear answers.
              </Typography>
            </Paper>
          </Grid>
          <Grid size={12} sx={{ mt: 6, borderTop: '1px solid #ccc' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 1,
                mt: 3,
                textAlign: 'center',
              }}
            >
              Still have questions about 5498 forms?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                fontWeight: 400,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Reach out to our friendly support team for all your Queries.
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, sm: 6 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Link href="mailto:support@taxzerone.com" underline="none">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Box>
                  <picture>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Email Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  support@taxzerone.com
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, sm: 6 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Link href="tel:+14084447120" underline="none">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Box>
                  <picture>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Email Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  (408) 444-7120
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, sm: 6 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                py: 3,
                textAlign: 'center',
                borderWidth: 2,
                borderColor: 'transparent',
                borderRadius: 5,
                height: '100%',
                transition: 'all 0.3s ease 0s',
                backgroundColor: '#f0f2f9',
                // '&:hover': {
                //   cursor: 'pointer',
                //   boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                // },
              }}
            >
              <Box>
                <picture>
                  <source
                    srcSet="/assets/images/chat-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/chat-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/chat-icon.png"
                    alt="Email Support"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                  textAlign: 'center',
                }}
              >
                Chat Support
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1098Series;
